<template>
  <div>
    <div>
      <h5 class="text-black">
        <strong>Pengirim</strong>
      </h5>
      <div>Pengirim Broadcast</div>
    </div>
    <div class="mt-2">
      <b-form>
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <b-form-group label-cols-md="3">
              <template #label>
                <h6 class="text-black">
                  <span class="text-primary">*</span> Judul Template
                </h6>
              </template>
              <b-form-input
                :value="templateName"
                placeholder="Masukan judul template"
                @input="$emit('update:templateName', $event)"
              />
            </b-form-group>
            <b-form-group label-cols-md="3">
              <template #label>
                <h6 class="text-black">
                  <span class="text-primary">*</span> Pilih Nomor Pengirim
                </h6>
              </template>
              <div
                ref="senderDropdownRef"
                class="position-relative"
              >
                <!-- Trigger Input Box -->
                <div
                  class="form-control d-flex align-items-center justify-content-between cursor-pointer"
                  style="min-height: 38px;"
                  @click="isDropdownOpen = !isDropdownOpen"
                >
                  <div
                    v-if="senderNumber && senderNumber.id !== 0"
                    class="d-flex align-items-center gap-1"
                  >
                    <span class="text-sm text-[#333333] font-medium">{{ senderNumber.label }}</span>
                    <span class="text-xs text-muted italic">- {{ senderNumber.type === 'komchat' ? 'Komchat Lite' : 'Komchat for Brands' }}</span>
                    <img
                      v-if="senderNumber.type !== 'komchat'"
                      src="https://storage.googleapis.com/komerce/assets/illustration/check-blue.svg"
                      alt="blue-check"
                      class="w-4 h-4"
                    >
                  </div>
                  <div
                    v-else-if="senderNumber && senderNumber.id === 0"
                    class="d-flex align-items-center"
                  >
                    <b-button
                      size="sm"
                      variant="primary"
                      class="py-0 px-1 text-xs"
                    >
                      {{ senderNumber.label }}
                    </b-button>
                  </div>
                  <span
                    v-else
                    class="text-sm text-gray-400"
                  >
                    Pilih Nomor Pengirim
                  </span>
                  <b-icon
                    :icon="isDropdownOpen ? 'chevron-up' : 'chevron-down'"
                    class="text-gray-500"
                  />
                </div>

                <!-- Dropdown Content Menu -->
                <div
                  v-show="isDropdownOpen"
                  class="position-absolute w-100 bg-white border rounded shadow-sm py-1 mt-0.5"
                  style="z-index: 1000; border-color: #E2E8F0; max-height: 260px; overflow-y: auto;"
                >
                  <!-- Existing Numbers List -->
                  <div v-if="optionSenderNumber.length > 0">
                    <div
                      v-for="(item, index) in optionSenderNumber"
                      :key="item.id || item.label || index"
                      class="d-flex align-items-center justify-content-between px-1 py-0.5 cursor-pointer hover:bg-gray-50 transition-colors"
                      :class="{ 'bg-[#FFF7ED]': isSenderSelected(item) }"
                      @click="onSelectSenderNumber(item)"
                    >
                      <b-button
                        v-if="item.id === 0"
                        size="sm"
                        variant="primary"
                        class="py-0 px-1 text-xs"
                      >
                        {{ item.label }}
                      </b-button>
                      <div
                        v-else
                        class="d-flex align-items-center gap-1"
                      >
                        <span class="text-sm text-[#333333] font-medium">{{ item.label }}</span>
                        <span class="text-xs text-muted italic">- {{ item.type === 'komchat' ? 'Komchat Lite' : 'Komchat for Brands' }}</span>
                        <img
                          v-if="item.type !== 'komchat'"
                          src="https://storage.googleapis.com/komerce/assets/illustration/check-blue.svg"
                          alt="blue-check"
                          class="w-4 h-4"
                        >
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <b-icon-check
                          v-if="isSenderSelected(item)"
                          class="text-primary font-bold mr-1"
                        />
                        <button
                          v-if="item.id !== 0"
                          type="button"
                          class="p-0 border-0 bg-transparent text-[#E31A1A] hover:text-red-700 cursor-pointer focus:outline-none d-flex align-items-center justify-content-center"
                          title="Hapus Nomor"
                          @click.stop="openDeleteModal(item)"
                        >
                          <b-icon-trash class="text-danger" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-else
                    class="px-1 py-0.5 text-xs text-muted text-center"
                  >
                    Tidak ada nomor pengirim tersedia
                  </div>

                  <!-- Bottom Add Number Row -->
                  <div
                    v-if="canAddNumber && !isAddingNumber"
                    class="pt-1 px-1 border-t border-gray-100 mt-0.5"
                  >
                    <button
                      type="button"
                      class="text-primary font-medium text-sm p-0 border-0 bg-transparent d-flex align-items-center gap-1 cursor-pointer hover:underline focus:outline-none w-100"
                      @click.stop="openAddNumber"
                    >
                      <b-icon-plus class="text-primary" />
                      Tambah Nomor
                    </button>
                  </div>
                  <div
                    v-else-if="canAddNumber && isAddingNumber"
                    class="pt-1 px-1 border-t border-gray-100 mt-0.5"
                  >
                    <b-input-group
                      prepend="+62"
                      size="sm"
                    >
                      <b-form-input
                        ref="inputNewPhone"
                        :value="newPhoneNumber"
                        type="text"
                        placeholder="85128889129"
                        maxlength="13"
                        autofocus
                        @input="onInputPhoneNumber"
                        @keydown.enter.prevent="submitNewNumber"
                        @keypress="onlyNumber"
                      />
                      <template #append>
                        <b-button
                          variant="primary"
                          size="sm"
                          :disabled="isSubmittingNewNumber || !newPhoneNumber"
                          @click.stop="submitNewNumber"
                        >
                          <b-spinner
                            v-if="isSubmittingNewNumber"
                            small
                            class="mr-1"
                          />
                          Tambah
                        </b-button>
                      </template>
                    </b-input-group>
                  </div>
                </div>
              </div>
            </b-form-group>
            <b-form-group label-cols-md="3">
              <template #label>
                <h6 class="text-black">
                  <span class="text-primary">*</span> Pilih Tipe Template
                </h6>
              </template>
              <v-select
                v-model="typeTemplateMessage"
                :disabled="disabledSelectTypeMessage"
                :options="optionsTemplate"
                :selectable="(option) => option.value !== 'utility' && option.value !== 'authentication' "
                label="label"
                placeholder="Pilih Tipe Template"
                @input="$emit('update:typeTemplateMessage', $event)"
              >
                <template #option="data">
                  <div v-if="data.description">
                    <span class="text-semibold">{{ data.label }}</span> - <span>{{ data.description }}</span>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <!-- Modal Konfirmasi Hapus Nomor Broadcast -->
    <ModalDeleteSenderPhone
      :visible="showDeleteModal"
      :item-to-delete="itemToDelete"
      @deleted="onNumberDeleted"
      @close="closeDeleteModal"
    />
  </div>
</template>

<script>
import VSelect from 'vue-select'
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import {
  cleanPhoneInput,
  handlePhoneKeypress,
  validatePhoneInput,
  registerNewWhatsAppNumber,
} from '@/views/pages/komship/customer/Ai/helper/whatsAppPhoneHelper'
import ModalDeleteSenderPhone from './ModalDeleteSenderPhone.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BButton,
    BSpinner,
    VSelect,
    ModalDeleteSenderPhone,
  },
  props: {
    templateName: {
      type: String,
      default: '',
    },
    senderNumber: {
      type: [String, Object],
      default: () => {},
    },
    optionsTemplate: {
      type: Array,
      default: () => [],
    },
    optionSenderNumber: {
      type: Array,
      default: () => [],
    },
    typeTemplateMessage: {
      type: Object,
      default: () => {},
    },
    disabledSelectTypeMessage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      isAddingNumber: false,
      newPhoneNumber: '',
      isSubmittingNewNumber: false,
      showDeleteModal: false,
      itemToDelete: null,
    }
  },
  computed: {
    canAddNumber() {
      const realCount = this.optionSenderNumber
        ? this.optionSenderNumber.filter(item => item.id !== 0).length
        : 0
      const storeCount = this.$store?.state?.komchat?.whatsAppList
        ? this.$store.state.komchat.whatsAppList.filter(item => item.is_scan !== false).length
        : 0
      return realCount < 3 && storeCount < 3
    },
  },
  watch: {
    senderNumber: {
      handler(newValue) {
        if (!newValue || (Array.isArray(newValue) && newValue.length === 0)) {
          this.$emit('update:typeTemplateMessage', null)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.$store.dispatch('whatsapp/getUpdateDashboardWa')
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(e) {
      if (this.$refs.senderDropdownRef && !this.$refs.senderDropdownRef.contains(e.target)) {
        this.isDropdownOpen = false
        this.isAddingNumber = false
      }
    },
    isSenderSelected(item) {
      if (!this.senderNumber) return false
      return this.senderNumber.id === item.id || this.senderNumber.label === item.label
    },
    onSelectSenderNumber(item) {
      this.$emit('update:senderNumber', item)
      this.isDropdownOpen = false
      this.isAddingNumber = false
    },
    openAddNumber() {
      if (!this.canAddNumber) {
        this.$toast_error({ message: 'Maksimal 3 nomor terhubung' })
        return
      }
      this.isAddingNumber = true
      this.$nextTick(() => {
        const el = this.$refs.inputNewPhone?.$el || this.$refs.inputNewPhone
        if (el?.focus) el.focus()
      })
    },
    openDeleteModal(item) {
      this.isDropdownOpen = false
      this.itemToDelete = item
      this.showDeleteModal = true
    },
    closeDeleteModal() {
      this.showDeleteModal = false
      this.itemToDelete = null
    },
    onNumberDeleted(item) {
      const id = item?.id
      if (
        this.senderNumber
        && (this.senderNumber.id === id || this.senderNumber.label === item?.label)
      ) {
        this.$emit('update:senderNumber', null)
      }
      this.$emit('refreshNumberList')
    },
    onInputPhoneNumber(val) {
      this.newPhoneNumber = cleanPhoneInput(val)
      this.$nextTick(() => {
        const el = this.$refs.inputNewPhone?.$el || this.$refs.inputNewPhone
        if (el) el.value = this.newPhoneNumber
      })
    },
    onlyNumber(event) {
      handlePhoneKeypress(event)
    },
    async submitNewNumber() {
      if (!this.canAddNumber) {
        this.$toast_error({ message: 'Maksimal 3 nomor terhubung' })
        return
      }

      const validation = validatePhoneInput(this.newPhoneNumber)
      if (!validation.isValid) {
        this.$toast_error({ message: validation.message })
        return
      }

      this.isSubmittingNewNumber = true
      try {
        const partnerId = this.$store?.state?.dashboard?.profile?.partner_id
        const { createdNumber, fullPhone } = await registerNewWhatsAppNumber({
          cleanedPhone: this.newPhoneNumber,
          partnerId,
        })

        this.$toast_success({ message: 'Nomor berhasil ditambahkan, silakan scan QR Code' })
        this.newPhoneNumber = ''
        this.isAddingNumber = false
        this.isDropdownOpen = false

        // Redirect to QR scan page with returnRoute
        this.$router.push({
          name: 'dashboard-whatsapp',
          params: {
            number: createdNumber || { phone_number: fullPhone, type: 'komchat' },
            type: 'komchat',
            returnRoute: this.$route.name,
            returnParams: this.$route.params,
            isNewNumber: true,
          },
        })
      } catch (error) {
        const errorMsg = error.message || error.response?.data?.message || 'Gagal menambahkan nomor'
        this.$toast_error({ message: errorMsg })
      } finally {
        this.isSubmittingNewNumber = false
      }
    },
  },
}
</script>
<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
